import React from "react";
import TRSlider from "./slider";

export const Header = (props) => {
  const slides = props.slides || [];
  const hasSlides = Array.isArray(slides) && slides.length > 0;
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                {hasSlides ? (
                  <TRSlider items={slides} fade={true} autoplay={true} autoplaySpeed={1800} />
                ) : (
                  <>
                    <h1>
                      {props.data ? props.data.title : "TR Assist - Profesyonel Yol Yardım Hizmetleri"}
                      <span></span>
                    </h1>
                    <p>{props.data ? props.data.paragraph : "Türkiye'de kurumsal firmalara ve sigorta şirketlerine 7/24 profesyonel yol yardım ve ikame araç hizmetleri sunuyoruz."}</p>
                    <a
                      href="#features"
                      className="btn btn-custom btn-lg page-scroll"
                      aria-label="TR Assist hizmetleri hakkında daha fazla bilgi alın"
                    >
                      Daha Fazla Bilgi
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
